import gettingStarted from '@docs/getting-started.md';
import concepts from '@docs/concepts.md';
import authentication from '@docs/authentication.md';
import files from '@docs/files.md';
import versions from '@docs/versions.md';
import compliance from '@docs/compliance.md';
import processing from '@docs/processing.md';
import search from '@docs/search.md';
import policies from '@docs/policies.md';
import sdk from '@docs/sdk.md';
import mcp from '@docs/mcp.md';
import restApi from '@docs/rest-api.md';
import dashboard from '@docs/dashboard.md';
import webhooks from '@docs/webhooks.md';
import hosting from '@docs/hosting.md';
import errors from '@docs/errors.md';
import guarantees from '@docs/guarantees.md';

/** Sidebar order and section ids. Edit markdown in src/docs/, then save. */
export const DOC_SECTIONS = [
  { id: 'getting-started', title: 'Getting started', markdown: gettingStarted },
  { id: 'concepts', title: 'Core concepts', markdown: concepts },
  { id: 'authentication', title: 'Authentication', markdown: authentication },
  { id: 'files', title: 'Files', markdown: files },
  { id: 'versions', title: 'Versions', markdown: versions },
  { id: 'compliance', title: 'Harbor Scan', markdown: compliance },
  { id: 'processing', title: 'Processing', markdown: processing },
  { id: 'search', title: 'Search', markdown: search },
  { id: 'policies', title: 'Policies', markdown: policies },
  { id: 'sdk', title: 'SDK', markdown: sdk },
  { id: 'mcp', title: 'MCP', markdown: mcp },
  { id: 'rest-api', title: 'HTTPS API', markdown: restApi },
  { id: 'dashboard', title: 'Dashboard', markdown: dashboard },
  { id: 'webhooks', title: 'Webhooks', markdown: webhooks },
  { id: 'hosting', title: 'Hosting', markdown: hosting },
  { id: 'errors', title: 'Errors & limits', markdown: errors },
  { id: 'guarantees', title: 'Guarantees', markdown: guarantees },
];
